import {
  CondensingUnitProductCapacities,
  CondensingUnitProductCapacity,
} from "../../types/CondensingUnitProductCapacity";
import { Service } from "../../types/Service";
import useProductWithThumbnails from "./useProductsWithThumbnails";

import useSingleCondensingUnits from "./useSingleCondensingUnits";

const useSingleCondensingUnitService = (): {
  condenserUnitService: Service<CondensingUnitProductCapacities>;
} => {
  const { condenserUnitService } = useSingleCondensingUnits();

  const { productsWithThumbnails: condensingUnitsWithThumbnailsService } =
    useProductWithThumbnails<CondensingUnitProductCapacity>(
      condenserUnitService
    );

  return {
    condenserUnitService: condensingUnitsWithThumbnailsService,
  };
};

export default useSingleCondensingUnitService;
